import styled from 'styled-components/macro';
import { Link } from '@redislabsdev/redis-ui-components';

export const SupportLink = styled(Link)`
  cursor: pointer;
`;
